import { Link, useLocation } from "react-router-dom";
import {
  OverviewIcon,
  ContentIcon,
  DemographicsIcon,
  DigitalIcon,
  PrintIcon,
  RadioIcon,
  TVIcon,
} from "../../../assets/NavbarIcons";
import navBarLinksData from "../../../utils/JSON/navBarLinks";
import FullLogo from "../../../assets/FullLogo";
import SidbarProfile from "../sidbarProfile/SidbarProfile";

const iconRenderer = (iconName: string) => {
  switch (iconName) {
    case "OverviewIcon":
      return <OverviewIcon />;
    case "ContentIcon":
      return <ContentIcon />;
    case "DemographicsIcon":
      return <DemographicsIcon />;
    case "DigitalIcon":
      return <DigitalIcon />;
    case "PrintIcon":
      return <PrintIcon />;
    case "RadioIcon":
      return <RadioIcon />;
    case "TVIcon":
      return <TVIcon />;
    default:
      return null;
  }
};

export default function Sidebar({ onlyMenu = false }) {
  const location = useLocation();
  const pathname = location.pathname;
  const param = "/" + pathname.split("/dashboard/")[1];
  return (
    <>
      <nav>
        <div className="min-w-[293px] h-full flex flex-col justify-between bg-white overflow-auto shadow-light ">
          <div className="flex flex-col gap-14">
            {!onlyMenu && (
              <div className="flex justify-left items-center gap-2 p-8 pt-3 pb-0">
                <FullLogo width="150" height="44" />
                <span className="mt-2 font-semibold text-xl text-inputBorder">|  Beta</span> 
              </div>
            )}
            <div className="flex flex-col justify-center pr-2">
              {navBarLinksData?.map((links) => {
                return (
                  <div
                    className={` pr-6 pl-8 p-2 ${param === links?.path ? " bg-softGrey  rounded-r-3xl  font-semibold " : ""} hover:bg-softGrey hover:rounded-r-3xl hover:font-semibold`}
                  >
                    <Link to={`/dashboard${links?.path}`}>
                      <div className="flex items-center gap-4 ">
                        <div className="w-[10%] flex justify-center">
                          {iconRenderer(links?.icon)}
                        </div>
                        <span className="text-[18px] font-poppins">
                          {links?.label}
                        </span>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>

          {!onlyMenu && (
            <div className="p-8 pt-0">
              <SidbarProfile />
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
